import React, { useRef, useEffect, useState } from "react";

export default function FiltroLiquidacionSemanas({
  initialFilters = {},
  onClose = () => {},
  onSubmit = () => {},
}) {
  const filtroRef = useRef(null);

  // ============================
  //        ESTADO (rehidratable)
  // ============================
  const [descripcion, setDescripcion] = useState(
    initialFilters.descripcion ?? ""
  );

  // ============================
  //   CERRAR CLICK FUERA / ESC
  // ============================
  useEffect(() => {
    const outside = (event) => {
      if (filtroRef.current && !filtroRef.current.contains(event.target)) {
        onClose();
      }
    };

    const esc = (event) => {
      if (event.key === "Escape") onClose();
    };

    document.addEventListener("mousedown", outside);
    document.addEventListener("keydown", esc);
    return () => {
      document.removeEventListener("mousedown", outside);
      document.removeEventListener("keydown", esc);
    };
  }, [onClose]);

  // ============================
  //        SUBMIT
  // ============================
  const handleSubmit = (event) => {
    event.preventDefault();

    onSubmit({
      descripcion: descripcion.trim() || null,
    });
  };

  // ============================
  //        RENDER
  // ============================
  return (
    <div className="drawer-backdrop">
      <div
        ref={filtroRef}
        onClick={(e) => e.stopPropagation()}
        className="drawer-panel overflow-auto"
      >
        <div className="flex justify-between items-center mb-6">
          <h2 className="text-title">Filtros</h2>
          <button onClick={onClose} className="btn-cancel" title="Cerrar">
            ×
          </button>
        </div>

        <form onSubmit={handleSubmit} className="grid grid-cols-1 gap-4">
          {/* DESCRIPCIÓN */}
          <div>
            <label className="form-label-fil">Descripción</label>
            <input
              type="text"
              className="input"
              value={descripcion}
              onChange={(e) => setDescripcion(e.target.value)}
              maxLength={60}
            />
          </div>

          <div className="text-right">
            <button type="submit" className="btn">
              Aplicar filtros
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}
